import type { Metric } from '@atlassian/browser-metrics/metric';

import { createCustomMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { PROFILE_CARD_QUERY_CUSTOM_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';
export const PROFILE_CARD_QUERY_METRIC: Metric = createCustomMetric({
	key: PROFILE_CARD_QUERY_CUSTOM_KEY,
});
